module.exports = __webpack_public_path__ + "static/img/3.28f1514.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/3.png
// module id = NFiH
// module chunks = 0